import { buildEnumMapProvider } from '../../utils/enum-map';
import { EnumSeverity } from '../../utils/enum-severity';
import { BackgroundProcessStatusEnum } from '../open-api/open-api-clients';

export const backgroundProcessStatusEnumMapProvider = buildEnumMapProvider(BackgroundProcessStatusEnum, getEnumText, getEnumSeverity);

function getEnumText(value: BackgroundProcessStatusEnum): string {
    switch (value) {
        case BackgroundProcessStatusEnum.None:
            return $localize`None`;
        case BackgroundProcessStatusEnum.Enqueued:
            return $localize`Enqueued`;
        case BackgroundProcessStatusEnum.Started:
            return $localize`Started`;
        case BackgroundProcessStatusEnum.Succeeded:
            return $localize`Succeeded`;
        case BackgroundProcessStatusEnum.Failed:
            return $localize`Failed`;
        case BackgroundProcessStatusEnum.Canceled:
            return $localize`Canceled`;
        case BackgroundProcessStatusEnum.Unfinished:
            return $localize`Unfinished`;
    }
}

function getEnumSeverity(value: BackgroundProcessStatusEnum): EnumSeverity {
    switch (value) {
        case BackgroundProcessStatusEnum.Failed:
            return EnumSeverity.error;
        case BackgroundProcessStatusEnum.Started:
            return EnumSeverity.warning;
        case BackgroundProcessStatusEnum.Succeeded:
            return EnumSeverity.success;
        default:
            return EnumSeverity.default;
    }
}

